import { render, staticRenderFns } from "./UserRequestDashboardComponent.vue?vue&type=template&id=145e2cd1"
import script from "./UserRequestDashboardComponent.vue?vue&type=script&lang=js"
export * from "./UserRequestDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports